import { updatePhotographyBrief_updateStructuredBrief_fields_SmartShootPhotographyFields as PhotographyBriefFields } from '__generated__/updatePhotographyBrief';
import Text from 'common/components/Text';
import TextArea from 'common/components/TextArea';
import TextList from 'common/components/TextList';
import { ObservableForm, Observe } from 'projects/components/ObservableForm';
import BriefStep from 'projects/components/SmartShoot/BriefStep';
import BriefStepField from 'projects/components/SmartShoot/BriefStepField';
import React from 'react';

interface Props {
    form: ObservableForm<PhotographyBriefFields>;
    step: number;
}

const PhotographyProjectDetailsForm: React.FunctionComponent<Props> = props => (
    <BriefStep
        step={props.step}
        heading="Your project details"
        subheading="Let's start with the basics"
        briefType="photo"
    >
        <Observe
            form={props.form}
            name="title"
            render={() => (
                <BriefStepField
                    label="What’s the name of your project?"
                    description="Give your photo shoot a name so you can find it in your projects."
                    required
                    errorMessage={props.form.getError('title')}
                >
                    <Text
                        placeholder="eg. Product shoot for Bilbo Baggins’ Hobbit Homewares"
                        maxLength={80}
                        fill
                        {...props.form.attach('title')}
                    />
                </BriefStepField>
            )}
        />

        <Observe
            form={props.form}
            name="description"
            render={() => (
                <BriefStepField
                    label="What do you need photographed?"
                    description="Tell us what you’re aiming to capture in your shoot: the purpose, audience and any ideas you have. Include whatever you think will help your photographer understand your vision and goals. The more details, the better!"
                    required
                    errorMessage={props.form.getError('description')}
                >
                    <TextArea
                        placeholder="Tell us all about your shoot..."
                        maxLength={1000}
                        fill
                        {...props.form.attach('description')}
                    />
                </BriefStepField>
            )}
        />

        <Observe
            form={props.form}
            name="inspirationUrls"
            render={() => (
                <BriefStepField
                    label="What will inspire your photographer?"
                    description="Help your photographer get to know you, your product and your brand. Include links to your website, social media, branding materials or photos you like (through a file-sharing link like Dropbox or Google Drive)."
                    errorMessage={props.form.getError('inspirationUrls')}
                >
                    <TextList
                        placeholder="Add links..."
                        fill
                        {...props.form.attach('inspirationUrls')}
                    />
                </BriefStepField>
            )}
        />
    </BriefStep>
);

export default PhotographyProjectDetailsForm;
